import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";

import "./Buttons.scss";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import WarningBeforeAction from "../../../../components/data-components/WarningBeforeAction";
import useErrorHandler, {
  ApplicationError,
} from "../../../../services/error-handler/ErrorHandlerService";
import { Reject } from "../../../../components/svg/svgImageList";
import { InvitationRequestActionProps } from "./InvitationRequestActionProps";
import useModal from "../../../../components/dialog/useModal";

export const RejectInvitationRequestButton = observer(function (
  props: InvitationRequestActionProps
) {
  const { themeClass } = useThemeService();
  const { isVisible, toggleModal } = useModal();
  const { handleErrorInSnackbar } = useErrorHandler();

  const { invitationRequestsStorage } = { ...props };

  const handleConfirmationAction = () => {
    rejectSelectedInvitation();
    toggleModal();
  };

  const rejectSelectedInvitation = useCallback(async () => {
    try {
      await invitationRequestsStorage.rejectForSelectedInvitation(
        invitationRequestsStorage.idOfSelectedItem
      );
    } catch (error) {
      const applicationError = error as ApplicationError;
      applicationError.withErrorMessage("default-error.collaboration.request.rejected");
      handleErrorInSnackbar(applicationError);
    }
  }, [handleErrorInSnackbar, invitationRequestsStorage]);

  return (
    <>
      <Button
        icon={{
          svg: Reject,
          textKey: "general.reject.collaboration",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-reject-invitation-request"]),
        }}
        disabled={invitationRequestsStorage.isActionButtonDisabled}
        onClick={toggleModal}
      />
      <WarningBeforeAction
        isVisible={isVisible}
        titleKey="MyCollaborationRequestPage.reject.confirmation.title"
        titleContext={{ organizationName: invitationRequestsStorage.selectedOrganizationName }}
        subtitleKey="MyCollaborationRequestPage.reject.confirmation"
        buttonOk={{
          id: "reject-ok",
          textKey: "general.reject.collaboration",
          action: handleConfirmationAction,
        }}
        toggleModal={toggleModal}
      />
    </>
  );
});
